import { render, staticRenderFns } from "./CourseConfirmChangeAnonymousStatus.vue?vue&type=template&id=4b93db4c&scoped=true"
import script from "./CourseConfirmChangeAnonymousStatus.vue?vue&type=script&lang=js"
export * from "./CourseConfirmChangeAnonymousStatus.vue?vue&type=script&lang=js"
import style0 from "./CourseConfirmChangeAnonymousStatus.vue?vue&type=style&index=0&id=4b93db4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93db4c",
  null
  
)

export default component.exports